import { NgModule } from "@angular/core";

import { AdminRoutingModule } from "./admin-routing.module";
import { SharedModule } from "../shared/shared.module";

import { UserService } from "./shared/user.service";

import { ThemeSettingsComponent } from "./theme-settings/theme-settings.component";
import { UserDetailComponent } from "./user-detail/user-detail.component";
import { UserListComponent } from "./user-list/user-list.component";

@NgModule({
    imports: [
        AdminRoutingModule,
        SharedModule,
    ],

    declarations: [
        ThemeSettingsComponent,
        UserDetailComponent,
        UserListComponent,
    ],

    providers: [
        UserService
    ]
})
export class AdminModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/admin/admin.module.ts